import { UseFormReturn } from 'react-hook-form'

import { TaxGroup } from '@/api/_schemas/management'
import { useTaxList } from '@/app/panel/management/price-list/_hooks/use-tax-list'
import { FormUpdateProduct } from '@/app/panel/management/price-list/_schemas/update-product'

export function useSyncTaxGroup() {
  const { data } = useTaxList('icmsSituacaoList', true)

  function syncTax(
    form: UseFormReturn<FormUpdateProduct>,
    taxGroup?: TaxGroup[0] | null,
  ) {
    if (!taxGroup) return

    const icmsTaxStatus =
      data?.find((item) => item.id === taxGroup.icms_situacao_tributaria)?.id ??
      ''

    form.setValue('cest', taxGroup.cest)
    form.setValue('cfop', taxGroup.cfop)
    form.setValue(
      'cofins_aliquota_percentual',
      Number(taxGroup.cofins_aliquota_percentual ?? 0).toFixed(2),
    )
    form.setValue(
      'cofins_situacao_tributaria',
      taxGroup.cofins_situacao_tributaria,
    )
    form.setValue('cofins_tipo_tributacao', taxGroup.cofins_tipo_tributacao)
    form.setValue(
      'icms_aliquota',
      Number(taxGroup.icms_aliquota ?? 0).toFixed(2),
    )
    form.setValue(
      'icms_modalidade_base_calculo',
      taxGroup.icms_modalidade_base_calculo,
    )
    form.setValue('icms_origem', taxGroup.icms_origem)
    form.setValue(
      'icms_percentual_reducao_base_calculo',
      taxGroup.icms_percentual_reducao_base_calculo,
    )
    form.setValue('icms_situacao_tributaria', icmsTaxStatus)
    form.setValue('ncm', taxGroup.ncm)
    form.setValue(
      'pis_aliquota_percentual',
      Number(taxGroup.pis_aliquota_percentual ?? 0).toFixed(2),
    )
    form.setValue('pis_situacao_tributaria', taxGroup.pis_situacao_tributaria)
    form.setValue('pis_tipo_tributacao', taxGroup.pis_tipo_tributacao)
    form.setValue('situacao', taxGroup.situacao)
  }

  return { syncTax }
}
